import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown } from "lucide-react";
import { useMediaQuery } from "react-responsive";
import { useState } from "react";
import { cn } from "@/utils/css";

export const SwitchButton = ({ className, onClick }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [rotation, setRotation] = useState(0);

    return (
        <button
            className={cn(
                "absolute md:static bottom-[-16px] right-2/4 translate-x-1/2  md:bottom-auto z-30 md:translate-x-0 h-8 md:h-12 w-20 md:w-6 flex flex-col items-center justify-center bg-cm-p-surface-hover rounded cursor-pointer",
                className,
                { "border-cm-p-outline": isMobile },
            )}
            onClick={() => {
                setRotation(rotation + 180);
                onClick();
            }}
        >
            <div style={{ transform: `rotate(${rotation}deg)` }} className="transition-transform duration-500 ease-in-out">
                {isMobile ? (
                    <div className="flex items-center justify-center">
                        <ChevronUp className="text-cm-p-accent w-3 h-3" />
                        <ChevronDown className="text-cm-p-accent w-3 h-3" />
                    </div>
                ) : (
                    <div>
                        <ChevronRight className="text-cm-p-accent w-3 h-3" />
                        <ChevronLeft className="text-cm-p-accent w-3 h-3" />
                    </div>
                )}
            </div>
        </button>
    );
};
